import TimelineCircleImage from '../../../../timeline/TimelineCircleImage/TimelineCircleImage';

const Image = require('../../../../../assets/img/timeline/modal/1998-newsletter.jpg');

const NewsletterContent = () => {
    return (
        <>
            <TimelineCircleImage image={Image} />
            <h4>
                The first bi-annual Breast Cancer Trials Supporter Newsletter
            </h4>
            <p>
                The first bi-annual Breast Cancer Trials Supporter Newsletter is published. Now in its 40th edition, this newsletter is produced especially for supporters to keep them informed of the research progress they are enabling through their generosity.
            </p>
        </>
    );
}

export default NewsletterContent;